
import { supabase } from "@/integrations/supabase/client";
import { User } from "../types";
import { toast } from "sonner";

export const useLogout = (
  setIsLoading: (loading: boolean) => void,
  setUser: (user: User | null) => void
) => {
  const logout = async (): Promise<void> => {
    setIsLoading(true);
    try {
      // First set user to null to update UI immediately
      setUser(null);
      
      // Clear local auth data
      sessionStorage.removeItem('supabase.auth.token');
      localStorage.removeItem('supabase.auth.token');
      
      // Then sign out from Supabase
      const { error } = await supabase.auth.signOut();
      
      if (error) {
        console.error("Supabase logout error:", error);
      }
      
      toast.success("Du har loggats ut");
      
      // Force page reload with cache clearing parameters to ensure clean state
      setTimeout(() => {
        window.location.href = '/?logout=' + new Date().getTime();
      }, 500);
    } catch (error) {
      console.error("Logout error:", error);
      
      // Still force reload to ensure user is logged out
      setTimeout(() => {
        window.location.href = '/?logout=' + new Date().getTime();
      }, 500);
    } finally {
      setIsLoading(false);
    }
  };

  return { logout };
};
